import { frFR } from "@material-ui/data-grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { findOne } from "../../../../services/Client__Service";
import {
  findAllByClient as findAllDocumentByClient,
  deleteOne,
  downloadfile,
  save,
} from "../../../../services/Document__Servive";
import navContext from "../../../Context/navContext";
import {
  MdDelete,
  MdDownload,
  MdEdit,
  MdOutlineRemoveRedEye,
  MdWarning,
} from "react-icons/md";
import BtnAddDocument from "../Document/BtnAdd/BtnAddDocument";
import notifyContext from "../../../Context/notifyContext";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../Loader/Loader";
import { ANNEE_TABS, MOIS_TABS } from "../../../../services/config";
import Modal from "../../../Modal/Modal";
import Form from "../Client/components/Form/Form";
import FormSalarie from "../Salarie/Form/FormSalarie";
import { FaFileArchive } from "react-icons/fa";
import FormDocument from "../Document/Form/FormDocument";
import CardClient from "../../../CardClient/CardClient";
import NotifyGestionnaire from "../NotifyGestionnaire/NotifyGestionnaire";
import { Button } from "@mui/material";
import ImportDocuments from "./ImportDocuments";

const ListDocumentForOneClient = () => {
  /* Handle Modal */
  const [viewSalarieId, setViewSalarieId] = useState(0);
  const [viewClientId, setViewClientId] = useState(0);
  const [viewDocumentId, setViewDocumentId] = useState(0);
  /* End Handle Modal */

  const paramsRoutes = useParams();

  const [id, setId] = useState(paramsRoutes.id);

  const [client, setClient] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [idDelete, setIdDelete] = useState(0);
  const [idArchived, setIdArchived] = useState(0);
  const [isArchivedLoading, setIsArchivedLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const redirect = useNavigate();

  const handleEdit = React.useCallback(
    (id) => () => {
      redirect(`/main/document/edit/${id}`);
    },
    []
  );

  const handleArchived = React.useCallback(
    (id) => () => {
      setIdArchived(id);
    },
    []
  );

  const handleDelete = React.useCallback(
    (id) => () => {
      setIdDelete(id);
    },
    []
  );

  const downloadHandle = React.useCallback(
    (filename, nameDownload) => () => {
      downloadfile(filename, nameDownload);
    },
    []
  );

  const columns = useMemo(
    () => [
      {
        field: "proprietaireName",
        headerName: "Salarié",
        minWidth: 200,
        flex: 1,
        renderCell: (params) => (
          <p
            style={{ cursor: "pointer" }}
            onClick={() => setViewSalarieId(params.row.salarie.id)}
          >
            {params.value}
          </p>
        ),
      },
      {
        field: "moisString",
        headerName: "Mois",
        minWidth: 110,
        type: "singleSelect",
        valueOptions: MOIS_TABS,
      },
      {
        field: "annee",
        headerName: "Année",
        minWidth: 120,
        type: "singleSelect",
        valueOptions: ANNEE_TABS,
      },
      {
        field: "Client",
        headerName: "Client",
        minWidth: 200,
        valueGetter: (params) => {
          return `${params.row.employeurName}`;
        },
        renderCell: (params) => (
          <p
            style={{ cursor: "pointer" }}
            onClick={() => setViewClientId(params.row.salarie.client.id)}
          >
            {params.value}
          </p>
        ),
      },

      {
        field: "statut",
        headerName: "Statut",
        width: 120,
        valueGetter: (params) => {
          if (parseInt(params.row.statut) === 1) return "Non Notifié";
          else if (parseInt(params.row.statut) === 2) return "Notifié";
          else return "Archivé";
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdDownload />}
            label="Télécharger"
            onClick={downloadHandle(params.row.chemin, params.row.nameDownload)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdOutlineRemoveRedEye />}
            label="Voir"
            onClick={() => setViewDocumentId(params.id)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdEdit />}
            label="Modifier"
            onClick={handleEdit(params.id)}
            showInMenu
            disabled={parseInt(params.row.statut) === 0}
          />,
          <GridActionsCellItem
            icon={<FaFileArchive />}
            label="Archiver"
            onClick={handleArchived(params.id)}
            showInMenu
            disabled={parseInt(params.row.statut) === 0}
          />,

          <GridActionsCellItem
            icon={<MdDelete />}
            label="Supprimer"
            onClick={handleDelete(params.id)}
            showInMenu
            disabled={parseInt(params.row.statut) === 0}
          />,
        ],
      },
    ],
    [handleDelete, handleEdit, downloadHandle]
  );
  const getMoisString = (mois) => {
    mois = parseInt(mois);
    if (mois >= 1 && mois <= 12) return MOIS_TABS[mois - 1];
    else return "";
  };

  const handleSubmitDelete = () => {
    deleteOneDocument(idDelete);
    setIdDelete(0);
    setIsDeleteLoading(true);
  };

  const handleSubmitArchived = () => {
    const doc = documents.find((elt) => {
      return elt.id === idArchived;
    });

    if (doc !== undefined) {
      archivedDocument({ ...doc, statut: 0 });
    }
    setIdArchived(0);
    setIsArchivedLoading(true);
  };
  useEffect(() => {
    if (client !== null) {
      nav({
        links: [
          {
            href: "/main/client",
            linkname: "Clients",
          },
          {
            href: "",
            linkname: client.nom,
          },
        ],
        children: <BtnAddDocument />,
      });
    }

    if (client === null) {
      fetchOneClient(id);
    }
  }, [client]);

  useEffect(() => {
    if (!isLoading) {
      let list = documents.map((doc) => {
        return {
          ...doc,
          moisString: getMoisString(doc.mois),
          proprietaireName: doc.salarie.fullname,
          employeurName: doc.salarie.client.nom,
          clientId: doc.salarie.client.id,
        };
      });
      setDocuments(list);
    }
  }, [isLoading]);

  const archivedDocument = async (doc) => {
    save(doc)
      .then(() => {
        setIsLoading(true);

        fetchAllDocumentByClient(id);

        notify("Archivé avec succès", "success");
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsArchivedLoading(false);
      });
  };

  const deleteOneDocument = async (idDelete) => {
    deleteOne(idDelete)
      .then(() => {
        setIsLoading(true);

        fetchAllDocumentByClient(id);
        notify("Supprimé avec succès", "success");
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsDeleteLoading(false);
      });
  };

  const fetchOneClient = async (clientId) => {
    findOne(id)
      .then((response) => {
        setClient(response.data);
        fetchAllDocumentByClient(clientId);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {});
  };

  const fetchAllDocumentByClient = async () => {
    findAllDocumentByClient(id)
      .then((response) => {
        setDocuments(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  const [openImport, setOpenImport] = useState(false);

  return (
    <Fragment>
      {openImport && (
        <ImportDocuments
          open={openImport}
          onClose={() => {
            setIsLoading(true);
            fetchAllDocumentByClient();
            setOpenImport(false);
          }}
          client={client}
        />
      )}
      <div className="document__items">
        <CardClient initialClient={client} />

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <h3>Liste des documents</h3>
          <Button
            onClick={() => {
              setOpenImport(true);
            }}
          >
            Importer
          </Button>
        </div>
        <NotifyGestionnaire initialClient={client} />
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <DataGrid
            rows={documents}
            columns={columns}
            pageSize={rowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            loading={isLoading}
            onPageSizeChange={handleChangeRowsPerPage}
            localeText={frFR.props.MuiDataGrid.localeText}
          />
        </div>
      </div>
      {isDeleteLoading && <Loader loadingMsg="Suppression en cours" />}
      {idDelete !== 0 && (
        <div className="deleteModal">
          <div className="deleteModal__content">
            <div className="deleteModal__question">
              <p>Êtes-vous sûr (e) de vouloir supprimer ce bulletin ?</p>
              <p style={{ color: "red" }}>
                <MdWarning size="25px" />
                Attention !!! Toutes les données de ce bulletin seront perdues.
              </p>
            </div>
            <div className="deleteModal__reponse">
              <button className="btn btn--outline" onClick={handleSubmitDelete}>
                Oui
              </button>
              <button className="btn" onClick={() => setIdDelete(0)}>
                Non
              </button>
            </div>
          </div>
        </div>
      )}

      {viewSalarieId !== 0 && (
        <Modal>
          <div className={`modal ${viewSalarieId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Salarié</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewSalarieId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormSalarie salarieId={viewSalarieId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewSalarieId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {viewClientId !== 0 && (
        <Modal>
          <div className={`modal ${viewClientId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Client</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewClientId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <Form clientId={viewClientId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewClientId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {isArchivedLoading && <Loader loadingMsg="En cours d'envoi" />}
      {idArchived !== 0 && (
        <div className="deleteModal">
          <div className="deleteModal__content">
            <div className="deleteModal__question">
              <p>Voulez-vous archiver ?</p>
              <p style={{ color: "red" }}>
                <MdWarning size="25px" />
                Attention ce document ne pourra plus être modifié ou supprimé
                !!!
              </p>
            </div>
            <div className="deleteModal__reponse">
              <button
                className="btn btn--outline"
                onClick={handleSubmitArchived}
              >
                Oui
              </button>
              <button className="btn" onClick={() => setIdArchived(0)}>
                Non
              </button>
            </div>
          </div>
        </div>
      )}

      {viewDocumentId !== 0 && (
        <Modal>
          <div className="modal modal--show">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Document</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewDocumentId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormDocument documentId={viewDocumentId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewDocumentId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default ListDocumentForOneClient;
